import {AuthenticationView} from "auth/AuthenticationView";
import {Main} from "Main";
import {BrowserUtils} from "utils/BrowserUtils";
import {HTMLUtils} from "utils/HTMLUtils";
import {StringUtils} from "utils/StringUtils";

export class StartTemplates
{
	private _startDiv: HTMLElement = document.getElementById("startdiv");
	private _startOverDiv: HTMLElement = document.getElementById("start_over");
	private _startButtons: HTMLElement;
	private _imageSelector: HTMLElement;

	private _arrayOfTemplates: {
		[key: string]: string[]
	} = {
		living_spaces: [
			"the_great_escape",
			"island_dream",
			"gulf_getaway",
			"easy_living",
			"rustic_dream"
		],
		agriculture: [
			"Hobby_and_Horse_Barn",
			"heritage_haven",
			"horse_haven",
			"the_work_horse"
		],
		workshops: [
			"light_stone_workshop",
			"charcoal_workshop",
			"a_place_for_everything",
			"the_man_cave",
			"lakeside_hideaway"
		],
		garages: [
			"spacious_garage",
			"hobby_shop",
			"countryside_living",
			"classic_car_garage",
			"copper_cove"
		],
		storage: [
			"Cowboys_Dream",
			"RV_Shelter",
			"american_man_cave",
			"recreational_retreat",
			"wrap_around_storage"
		]
	};

	private readonly _extension = "jpg";

	constructor()
	{
		this._startDiv.onclick = (event: MouseEvent) =>
		{
			
			if (event.target === event.currentTarget)
			{
				// User clicked on the background
				this.onEnd();
			}
		};

		if (Main.getInstance().authentication.isCurrentProjectInitial())
		{
			this._startDiv.classList.remove("hidden");
			this._startButtons = this.getElementByClass("startButtons");
			this._startButtons.classList.remove("hidden");
			this.getElementByClass("close").addEventListener("click", this.onEnd);
			this.getElementByClass("signin").addEventListener("click", AuthenticationView.redirectToLogin);
			this.getElementByClass("newproject").addEventListener("click", this.onEnd);
			this.getElementByClass("template").addEventListener("click", this.onStartTemplateClick);
			this.getElementByClass("help").addEventListener("click", Main.getInstance().onHelpBtnClick);
			this._startOverDiv.onclick = this.onShowStartDiv;
		}
	}

	private getElementByClass(className: string)
	{
		return this._startDiv.querySelector(`.${className}`) as HTMLDivElement;
	}

	private onEnd = () =>
	{
		this.getElementByClass("close").removeEventListener("click", this.onEnd);
		this.getElementByClass("signin").removeEventListener("click", AuthenticationView.redirectToLogin);
		this.getElementByClass("newproject").removeEventListener("click", this.onEnd);
		this.getElementByClass("template").removeEventListener("click", this.onStartTemplateClick);;
		this.getElementByClass("help").removeEventListener("click", Main.getInstance().onHelpBtnClick);

		this._imageSelector?.remove();

		this._startDiv.classList.add("hidden");
	};

	private onShowStartDiv = () =>
	{
		this._startDiv.classList.remove("hidden");
	};

	private onStartTemplateClick = () =>
	{
		this._startButtons.classList.add("hidden");
		this.showImageSelector("templateCategories");
	};

	private showImageSelector(type: "templateCategories" | "templateCategory", templateCategory: string = "")
	{
		const imageSelector = document.createElement("div");
		this._imageSelector = imageSelector;
		imageSelector.classList.add("imageSelector");
		imageSelector.classList.add("vbox");
		imageSelector.classList.add("boxShadowedWindow");
		imageSelector.style.backgroundColor = "white";
		imageSelector.style.borderRadius = "5px";
		imageSelector.style.overflowY = "auto";
		imageSelector.style.maxWidth = "1000px";
		imageSelector.style.textAlign = "center";
		const header = document.createElement("div");
		header.classList.add("hbox");
		header.style.alignItems = "center";
		const title = document.createElement("div");
		title.textContent = type === "templateCategories" ? "Choose a building style" : templateCategory;
		title.style.textTransform = "uppercase";
		title.style.fontSize = "1.8rem";
		title.style.fontWeight = "bold";
		title.style.marginLeft = "10px";
		title.style.marginTop = "10px";
		title.style.marginBottom = "10px";
		const close = document.createElement("div");
		close.textContent = "X";
		close.classList.add("close");

		const closeImageSelector = () =>
		{
			HTMLUtils.clearElement(imageSelector, true);
		};
		close.addEventListener("click", () =>
		{
			closeImageSelector();
			if (type === "templateCategories")
			{
				this._startButtons.classList.remove("hidden");
			}
			else
			{
				this.showImageSelector("templateCategories");
			}
		});
		header.style.backgroundColor = "#515151";
		header.appendChild(title);
		header.appendChild(close);
		header.style.marginBottom = "3px";
		imageSelector.appendChild(header);

		const thumbnailContainer = document.createElement("div");
		thumbnailContainer.style.padding = "20px";

		if (type === "templateCategories")
		{
			for (const categoryKey in this._arrayOfTemplates)
			{
				const thumbnail = this.createThumbnail(
					`assets/images/templates/${categoryKey}/${this._arrayOfTemplates[categoryKey][0]}.${this._extension}`,
					categoryKey.replace(/_/g, " ")
				);
				thumbnail.addEventListener("click", () =>
				{
					closeImageSelector();
					this.showImageSelector("templateCategory", categoryKey);
				});
				thumbnailContainer.appendChild(thumbnail);
			}
		}
		else
		{
			for (const templateName of this._arrayOfTemplates[templateCategory])
			{
				const templateNameWithSpaces = templateName.replace(/_/g, " ");
				const thumbnail = this.createThumbnail(
					`assets/images/templates/${templateCategory}/${templateName}.${this._extension}`,
					templateNameWithSpaces
				);
				thumbnail.addEventListener("click", () =>
				{
					const projectName = encodeURIComponent(StringUtils.capitalizeEachWordInSentence(templateNameWithSpaces));
					window.open(`${BrowserUtils.getCurrentBaseURL()}?email=${encodeURIComponent("sales@muellerinc.com")}&project=${projectName}`, "_self");
				});
				thumbnailContainer.appendChild(thumbnail);
			}
		}
		
		thumbnailContainer.appendChild(this.createDesignMyOwnThumbnail());

		imageSelector.appendChild(thumbnailContainer);

		this._startDiv.appendChild(imageSelector);
	}

	private createDesignMyOwnThumbnail()
	{
		const fileName = "design_my_own";

		const thumbnail = this.createThumbnail(
			`assets/images/templates/${fileName}.${this._extension}`,
			fileName.replace(/_/g, " ")
		);

		thumbnail.addEventListener("click", this.onEnd);

		return thumbnail;
	}

	private createThumbnail(imgSrc: string, label: string)
	{
		const thumbnail = document.createElement("div");
		thumbnail.classList.add("boxShadowedWindow");
		thumbnail.classList.add("vbox");
		thumbnail.style.display = "inline-block";
		thumbnail.style.margin = "5px";
		thumbnail.style.cursor = "pointer";
		thumbnail.style.borderRadius = "5px";
		thumbnail.style.overflow = "hidden";
		thumbnail.style.position = "relative";

		const img = this.createThumbnailImage(imgSrc);
		const labelElement = this.createThumbnailLabel(label);

		thumbnail.appendChild(img);
		thumbnail.appendChild(labelElement);

		return thumbnail;
	}

	private createThumbnailImage(imgSrc: string)
	{
		const img = document.createElement("div");
		img.style.backgroundImage = `url(${imgSrc})`;
		img.style.width = "299px";
		img.style.height = "202px";
		img.style.backgroundSize = "cover";

		return img;
	}

	private createThumbnailLabel(label: string)
	{
		const el = document.createElement("div");
		el.textContent = label;
		el.style.textTransform = "uppercase";
		el.style.color = "white";
		el.style.fontSize = "1.5rem";
		el.style.fontWeight = "bold";
		el.style.textShadow = "2px 2px 4px rgba(0, 0, 0, 0.5)";
		el.style.position = "absolute";
		el.style.width = "100%";
		el.style.textAlign = "left";
		el.style.top = "0";
		el.style.left = "0";
		el.style.backgroundColor = "rgba(0, 0, 0, 0.2)";
		el.style.padding = "10px 20px";
		el.style.borderRadius = "5px 5px 0 0";

		return el;
	}
}
